import REDUX_DOMAIN from '../../../redux/constants/domain'
import createDomainListReduxUtil from '../../../redux/utils/create-domain-list'
import getClassNameReduxUtil from '../../../redux/utils/get-class-name'
import getDomainListPathsReduxUtil from '../../../redux/utils/get-domain-list-path'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import removeReferenceUtil from '../../../references/utils/remove'
import logSystemUtil from '../../../logs/redux/actions/log'
import setUtil from '../../../../utils/set'
import { getObjectUtil, uniqArrayUtil } from 'packages/src'

export default function removeInstanceFromDomainListsReduxUtil (props) {
  const {
    instance,
    domainListPath
  } = props
  let { state } = props
  logSystemUtil('removeInstanceFromDomainListsReduxUtil').debug('domainListPath=', domainListPath)

  const id = getIdReduxUtil(instance)
  const domainListPaths = getDomainListPathsReduxUtil({ instance, state })
  if (domainListPath) {
    domainListPaths.push(domainListPath)
  }
  logSystemUtil('removeInstanceFromDomainListsReduxUtil').debug('domainListPaths=', domainListPaths)

  domainListPaths.forEach(domainListPath => {
    const logPrefix = `className=${getClassNameReduxUtil(instance)} id=${id} domainListPath=${domainListPath}`
    logSystemUtil('removeInstanceFromDomainListsReduxUtil').debug(`${logPrefix}`)
    // Get the DomainList
    const domainList = (
      getObjectUtil(state, domainListPath || 'all') ||
      createDomainListReduxUtil()
    )
    const domainListData = getObjectUtil(domainList, 'data') || []

    // Set the sorted instance
    const domainPath = REDUX_DOMAIN[getClassNameReduxUtil(instance)]
    const domain = getObjectUtil(state, domainPath)
    if (!domain) {
      logSystemUtil('removeInstanceFromDomainListsReduxUtil').warn(`${logPrefix} domainPath not found`)
      return
    }

    logSystemUtil('removeInstanceFromDomainListsReduxUtil').debug(`${logPrefix} domainListData=`, domainListData)
    // Add the instance to the DomainList
    const newInstances = domainListData.filter(idParam => idParam !== id)

    // Add the instance to the DomainList
    const newDomainList = setUtil(domainList, 'data', uniqArrayUtil(newInstances))

    // Update the DomainList
    const newState = setUtil(state, domainListPath, newDomainList)
    logSystemUtil('removeInstanceFromDomainListsReduxUtil').debug(`${logPrefix} newDomainList=`, newDomainList)

    const deleteReferenceObj = removeReferenceUtil({
      instance,
      referencePath: `${domainListPath}.data`,
      state: newState
    })

    if (!deleteReferenceObj) {
      state = newState
    } else {
      state = deleteReferenceObj.state
    }
  })
  return state
}
